import {AxiosInstance} from "axios";
import {IRole} from "../types/models/Role";
import {makeAutoObservable} from "mobx";
import {IResult} from "../services/Result";
import {AxiosResponseHelper} from "../utilities/AxiosResponseHelper";
import {IAnalyticsStore} from "./AnalyticsStore";

export interface IRoleStore {
  roles: IRole[];
  isLoading: boolean;
  error: { title: string; message: string };
  getRoles: (apiInstance: AxiosInstance) => Promise<void>;
}

export class RoleStore implements IRoleStore {
  error: { title: string; message: string };
  isLoading: boolean = false;
  roles: IRole[];
  _analytics_store: IAnalyticsStore;
  constructor(analytics_store: IAnalyticsStore) {
    this._analytics_store = analytics_store;
    makeAutoObservable(this);  
  }
    
  public async getRoles(apiInstance: AxiosInstance){
    this.isLoading = true;
    const response = await apiInstance.get<IResult<IRole[]>>('api/Roles');
        
    if (AxiosResponseHelper.IsSuccessfulResponse(response) && response.data.data){
      this.roles = response.data.data;
    } else {
      let errorMsg = "Cannot retrieve list of roles"
      AxiosResponseHelper.ReportErrors(this._analytics_store, errorMsg, response.data)
    }
      this.isLoading = false;
  }
}
